var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "rounded transition duration-150" }, [
    _c("div", { staticClass: "px-4 py-5 border-b border-gray-200 sm:px-6" }, [
      _c("h3", { staticClass: "text-lg leading-6 font-medium text-gray-900" }, [
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm.subtitle
        ? _c(
            "p",
            { staticClass: "mt-1 max-w-2xl text-sm leading-5 text-gray-500" },
            [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
          )
        : _vm._e(),
    ]),
    _c(
      "dl",
      {
        staticClass:
          "grid grid-cols-1 col-gap-4 row-gap-8 sm:grid-cols-2 px-4 py-5 sm:px-6",
      },
      [_vm._t("content")],
      2
    ),
    _c("div", { staticClass: "-mt-px flex" }, [
      _c(
        "button",
        {
          class: _vm.buttonClasses,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("update")
            },
          },
        },
        [
          _c("EditIcon", { staticClass: "w-5 h-5 text-gray-400" }),
          _c("span", { staticClass: "ml-3" }, [_vm._v(" Edit ")]),
        ],
        1
      ),
      _c(
        "button",
        {
          class: _vm.buttonClasses,
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.$emit("remove")
            },
          },
        },
        [
          _c("RemoveIcon", { staticClass: "w-5 h-5 text-gray-400" }),
          _c("span", { staticClass: "ml-3" }, [_vm._v(" Remove ")]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }